module.exports = __webpack_public_path__ + "assets/b119.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b119.png
// module id = 591
// module chunks = 0